import { render, staticRenderFns } from "./the-side-bar.vue?vue&type=template&id=2bfd12a2&scoped=true&"
import script from "./the-side-bar.vue?vue&type=script&lang=js&"
export * from "./the-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./the-side-bar.vue?vue&type=style&index=0&id=2bfd12a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd12a2",
  null
  
)

export default component.exports